/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Label,
  Modal,
  Table,
  TextInput,
} from "flowbite-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import type { FC } from "react";
import * as XLSX from "xlsx";
import { useEffect, useState, useRef } from "react";
import {
  HiBell,
  HiCheckCircle,
  HiChevronLeft,
  HiChevronRight,
  HiCog,
  HiDocumentDownload,
  HiDotsVertical,
  HiExclamationCircle,
  HiHome,
  HiOfficeBuilding,
  HiOutlineExclamationCircle,
  HiOutlinePencilAlt,
  HiPlus,
  HiSave,
  HiTrash,
  HiUpload,
  HiUserAdd,
  HiXCircle,
  HiFilter,
} from "react-icons/hi";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { format, parse } from "date-fns";
import { FadeLoader } from "react-spinners";

import { NotificationBellDropdown } from "./navbar";
import { useAppContext } from "../context/AppContext";
import { companyService } from "../services/main";
import Select from "react-select";
import { User } from "../services/user";
const UserListPage: FC = function () {
  return (
    <NavbarSidebarLayout isFooter={false}>
      <div className="block items-center justify-between border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <div className="mb-1 w-full">
          <div className="mb-4">
            <Breadcrumb className="mb-4">
              <Breadcrumb.Item>
                <div className="flex items-center gap-x-3">
                  <HiHome className="text-xl" />
                  <span className="dark:text-white">Home</span>
                </div>
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/users/list">Users</Breadcrumb.Item>
              <Breadcrumb.Item>List</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
              All users
            </h1>
          </div>
          <div className="sm:flex">
            <div className="mb-3 hidden items-center dark:divide-gray-700 sm:mb-0 sm:flex sm:divide-x sm:divide-gray-100">
              <form className="lg:pr-3">
                <Label htmlFor="users-search" className="sr-only">
                  Search
                </Label>
                <div className="relative mt-1 lg:w-64 xl:w-96">
                  <TextInput
                    id="users-search"
                    name="users-search"
                    placeholder="Search for users"
                  />
                </div>
              </form>
              <div className="mt-3 flex space-x-1 pl-0 sm:mt-0 sm:pl-2">
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Configure</span>
                  <HiCog className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Delete</span>
                  <HiTrash className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Purge</span>
                  <HiExclamationCircle className="text-2xl" />
                </a>
                <a className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                  <span className="sr-only">Settings</span>
                  <HiDotsVertical className="text-2xl" />
                </a>
              </div>
            </div>
            <div className="ml-auto flex items-center space-x-2 sm:space-x-3">
              <AddCompanyModal />
              <Button color="gray">
                <div className="flex items-center gap-x-3">
                  <HiDocumentDownload className="text-xl" />
                  <span>Export</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden shadow">
              {/* <AllCompaniesTable /> */}
            </div>
          </div>
        </div>
      </div>
    </NavbarSidebarLayout>
  );
};



const initialFormData = {
  name: "",
  website: "",
  linkedinUrl: "",
  phoneNumber: "",
  address: "",
  city: "",
  zipcode: "",
  stateAbbr: "",
  country: "",
  sector: "",
  size: "",
  revenue: "",
  taxIdentifier: "",
  description: "",
  contextLinks: [],
};

// Dropdown options for Company form
const SECTOR_OPTIONS = [
  { value: "", label: "Select Sector" },
  { value: "Technology", label: "Technology" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Finance", label: "Finance" },
  { value: "Education", label: "Education" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Retail", label: "Retail" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Consulting", label: "Consulting" },
  { value: "Media & Entertainment", label: "Media & Entertainment" },
  { value: "Energy", label: "Energy" },
  { value: "Transportation", label: "Transportation" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "Legal", label: "Legal" },
  { value: "Non-Profit", label: "Non-Profit" },
  { value: "Other", label: "Other" },
];

const SIZE_OPTIONS = [
  { value: "", label: "Select Company Size" },
  { value: "1-10", label: "1-10 employees" },
  { value: "11-50", label: "11-50 employees" },
  { value: "51-200", label: "51-200 employees" },
  { value: "201-500", label: "201-500 employees" },
  { value: "501-1000", label: "501-1000 employees" },
  { value: "1001-5000", label: "1001-5000 employees" },
  { value: "5000+", label: "5000+ employees" },
];

const COUNTRY_OPTIONS = [
  { value: "", label: "Select Country" },
  { value: "United States", label: "United States" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "Canada", label: "Canada" },
  { value: "Australia", label: "Australia" },
  { value: "India", label: "India" },
  { value: "Germany", label: "Germany" },
  { value: "France", label: "France" },
  { value: "Japan", label: "Japan" },
  { value: "China", label: "China" },
  { value: "Brazil", label: "Brazil" },
  { value: "Mexico", label: "Mexico" },
  { value: "Spain", label: "Spain" },
  { value: "Italy", label: "Italy" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "Singapore", label: "Singapore" },
  { value: "Other", label: "Other" },
];

const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];

export const AddCompanyModal: FC = () => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const { companies, setCompanies } = useAppContext();
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [formData, setFormData] = useState(initialFormData) as any;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;

    if (name === "contextLinks") {
      setFormData((prev: any) => ({
        ...prev,
        contextLinks: value.split(",").map(link => link.trim()),
      }));
    } else {
      setFormData((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleAddCompany = async () => {
    // Validation
    if (!formData.name) {
      toast.error("Company name is required");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...formData,
        accountManager: user.id,
        // Clean up contextLinks
        contextLinks: formData.contextLinks && typeof formData.contextLinks === 'string' 
          ? formData.contextLinks.split(",").map(link => link.trim()).filter(Boolean)
          : formData.contextLinks || [],
      };
      const response = await companyService.createCompany(payload);
      onUpdate();
      setFormData(initialFormData);
      setOpen(false);
      toast.success("Company Added Successfully!");
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Failed to add company. Please try again.");
      console.error("Failed to add company", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyDataExport = () => {
    const excludeFields = ["id", "accountManagerId", "createdAt", "updatedAt"];

    // Create a flat + filtered version dynamically
    const transformed = companies.map((item: any) => {
      const result: any = {};

      Object.entries(item).forEach(([key, value]) => {
        if (!excludeFields.includes(key)) {
          // If it's an array, join values; else, use as-is
          result[key] = Array.isArray(value) ? value.join(", ") : value;
        }
      });

      return result;
    });

    const worksheet = XLSX.utils.json_to_sheet(transformed);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Companies");

    XLSX.writeFile(workbook, "companies_export.xlsx");
  };

  const onUpdate = async () => {
    try {
      setLoading(true);
      const response = await companyService.listCompanies();
      const sorted = response.data.companies.sort((a: any, b: any) => a.id - b.id);
      setCompanies(sorted);
    } catch (error) {
      console.error("Failed to refresh companies", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <Button color="primary" onClick={() => {
        setOpen(true)
      }}>
        <div className="flex items-center gap-x-3">
          <HiPlus className="text-xl" />
          New Company
        </div>
      </Button>
      <Button color="gray" onClick={handleCompanyDataExport}>
        <div className="flex items-center gap-x-3">
          <HiDocumentDownload className="text-xl" />
          <span>Export</span>
        </div>
      </Button>
      <ImportCompaniesModal onUpdate={onUpdate} />
      <Modal size="xl" onClose={() => setOpen(false)} show={isOpen}>
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Add New Company</strong>
        </Modal.Header>
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Company Name */}
                <div className="flex flex-col">
                  <Label htmlFor="name" className="mb-2">
                    Company Name <span className="text-red-500">*</span>
                  </Label>
                  <TextInput
                    id="name"
                    name="name"
                    placeholder="Enter company name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Website */}
                <div className="flex flex-col">
                  <Label htmlFor="website" className="mb-2">Website</Label>
                  <TextInput
                    id="website"
                    name="website"
                    type="url"
                    placeholder="https://example.com"
                    value={formData.website}
                    onChange={handleChange}
                  />
                </div>

                {/* LinkedIn URL */}
                <div className="flex flex-col">
                  <Label htmlFor="linkedinUrl" className="mb-2">LinkedIn URL</Label>
                  <TextInput
                    id="linkedinUrl"
                    name="linkedinUrl"
                    type="url"
                    placeholder="https://linkedin.com/company/..."
                    value={formData.linkedinUrl}
                    onChange={handleChange}
                  />
                </div>

                {/* Phone Number */}
                <div className="flex flex-col">
                  <Label htmlFor="phoneNumber" className="mb-2">Phone Number</Label>
                  <TextInput
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder="+1 234 567 8900"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Location Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Location Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Address */}
                <div className="flex flex-col sm:col-span-2">
                  <Label htmlFor="address" className="mb-2">Address</Label>
                  <TextInput
                    id="address"
                    name="address"
                    placeholder="Street address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>

                {/* City */}
                <div className="flex flex-col">
                  <Label htmlFor="city" className="mb-2">City</Label>
                  <TextInput
                    id="city"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>

                {/* State */}
                <div className="flex flex-col">
                  <Label htmlFor="stateAbbr" className="mb-2">State/Province</Label>
                  <select
                    id="stateAbbr"
                    name="stateAbbr"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.stateAbbr}
                    onChange={handleChange}
                  >
                    <option value="">Select State</option>
                    {US_STATES.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Zipcode */}
                <div className="flex flex-col">
                  <Label htmlFor="zipcode" className="mb-2">Zip/Postal Code</Label>
                  <TextInput
                    id="zipcode"
                    name="zipcode"
                    placeholder="12345"
                    value={formData.zipcode}
                    onChange={handleChange}
                  />
                </div>

                {/* Country */}
                <div className="flex flex-col">
                  <Label htmlFor="country" className="mb-2">Country</Label>
                  <select
                    id="country"
                    name="country"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.country}
                    onChange={handleChange}
                  >
                    {COUNTRY_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Business Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Business Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Sector */}
                <div className="flex flex-col">
                  <Label htmlFor="sector" className="mb-2">Sector</Label>
                  <select
                    id="sector"
                    name="sector"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.sector}
                    onChange={handleChange}
                  >
                    {SECTOR_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Size */}
                <div className="flex flex-col">
                  <Label htmlFor="size" className="mb-2">Company Size</Label>
                  <select
                    id="size"
                    name="size"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.size}
                    onChange={handleChange}
                  >
                    {SIZE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Revenue */}
                <div className="flex flex-col">
                  <Label htmlFor="revenue" className="mb-2">Revenue</Label>
                  <TextInput
                    id="revenue"
                    name="revenue"
                    placeholder="Annual revenue"
                    value={formData.revenue}
                    onChange={handleChange}
                  />
                </div>

                {/* Tax Identifier */}
                <div className="flex flex-col">
                  <Label htmlFor="taxIdentifier" className="mb-2">Tax ID</Label>
                  <TextInput
                    id="taxIdentifier"
                    name="taxIdentifier"
                    placeholder="Tax identification number"
                    value={formData.taxIdentifier}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Additional Information Section */}
            <div>
              <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">Additional Information</h3>
              
              {/* Description */}
              <div className="mb-4">
                <Label htmlFor="description" className="mb-2">Description</Label>
                <textarea
                  id="description"
                  name="description"
                  rows={4}
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  placeholder="Enter company description..."
                  value={formData.description}
                  onChange={(e) => setFormData((prev: any) => ({ ...prev, description: e.target.value }))}
                />
              </div>

              {/* Context Links */}
              <div className="mb-4">
                <Label htmlFor="contextLinks" className="mb-2">Context Links (comma-separated)</Label>
                <TextInput
                  id="contextLinks"
                  name="contextLinks"
                  placeholder="https://example1.com, https://example2.com"
                  value={Array.isArray(formData.contextLinks) ? formData.contextLinks.join(", ") : formData.contextLinks}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button color="gray" onClick={() => setOpen(false)} disabled={loading}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleAddCompany} disabled={loading}>
              {loading ? "Adding..." : "Add Company"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>


    </>
  );
};

const ImportCompaniesModal: FC<{ onUpdate: () => void }> = ({ onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null) as any;
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (selected) setFile(selected);
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("accountManagerId", String(user.id || user.accountManagerId || ""));
    try {
      const response = await companyService.bulkUploadCompanies(formData);
      console.log("Upload response:", response);
      toast.success(`Companies uploaded successfully! ${response.data?.created || 0} companies created.`);
      onUpdate();
      setFile(null);
      setOpen(false);
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || error.message || "Upload failed";
      toast.error(errorMessage);
      console.error("Upload error:", error);
    } finally {
      setLoading(false);
    }
  };
  function downloadCompanyTemplateHeadersOnly() {
    const headers = [
      "name",
      "website",
      "linkedinUrl",
      "phoneNumber",
      "address",
      "city",
      "zipcode",
      "stateAbbr",
      "country",
      "sector",
      "size",
      "revenue",
      "taxIdentifier",
      "description",
      "contextLinks"
    ];


    // Create worksheet with one empty row, using headers
    const worksheet = XLSX.utils.json_to_sheet([{}], { header: headers });

    // Ensure headers appear in the desired order
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

    XLSX.writeFile(workbook, "company_template.xlsx");
  }


  return (
    <>
      <Button color="gray" onClick={(e: any) => {
        e.stopPropagation();
        setOpen(true);
      }}>
        <div className="flex items-center gap-x-2">
          <HiUpload className="text-lg" />
          Import
        </div>
      </Button>

      <Modal onClose={() => setOpen(false)} show={isOpen} size="md">
        <Modal.Header className="px-6 pb-0 pt-6">
          <span className="sr-only">Import Contact</span>
        </Modal.Header>
        <Modal.Body className="px-6 pb-6 pt-0">
          <div className="flex justify-between items-center my-4">
            <p className="text-xl text-gray-500 flex justify-center ">
              Download Template
            </p>
            <Button color="primary" onClick={downloadCompanyTemplateHeadersOnly} isProcessing={loading}>
              Download
            </Button>
          </div>
          <hr className="my-4" />
          <div className="mb-4">
            <div className="flex items-center justify-center w-full">
              <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">XLSX, XLS (Max upload size - 10mb)</p>
                  <span className="font-semibold text-xs text-gray-500 dark:text-gray-400">{file?.name}</span>
                </div>
                <input type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileChange} id="dropzone-file" className="hidden" />
              </label>
            </div>

          </div>
          <div className="flex gap-3">
            <Button color="primary" onClick={handleUpload} isProcessing={loading} disabled={!file}>
              Upload
            </Button>
            <Button color="gray" onClick={() => { setOpen(false); setFile(null) }} disabled={loading}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


// { searchTerm, filters } as prop later use
export const AllCompaniesTable: FC<any> = ({ paginatedCompanies }) => {
  const { companies, setCompanies } = useAppContext();
  const [loading, setLoading] = useState(false);

  const onUpdate = async () => {
    try {
      setLoading(true);
      const response = await companyService.listCompanies();
      const sorted = response.data.companies.sort((a: any, b: any) => a.id - b.id);
      setCompanies(sorted);
    } catch (error) {
      console.error("Failed to refresh companies", error);
    } finally {
      setLoading(false);
    }
  };

  // Inline Editable Status Component
  const InlineStatusEditor: FC<{ status: string; companyId: number; onUpdate: () => void }> = ({ status, companyId, onUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(status);

    const handleStatusChange = async (newStatus: string) => {
      if (newStatus === currentStatus) {
        setIsEditing(false);
        return;
      }
      try {
        setUpdating(true);
        await companyService.updateCompany(companyId, { status: newStatus });
        setCurrentStatus(newStatus);
        setIsEditing(false);
        onUpdate();
        toast.success("Status updated successfully!");
      } catch (error) {
        console.error("Failed to update status", error);
        toast.error("Failed to update status");
      } finally {
        setUpdating(false);
      }
    };

    useEffect(() => {
      setCurrentStatus(status);
    }, [status]);

    if (isEditing) {
      return (
        <select
          value={currentStatus}
          onChange={(e) => handleStatusChange(e.target.value)}
          onBlur={() => setIsEditing(false)}
          autoFocus
          disabled={updating}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            currentStatus === 'ACTIVE' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' :
            'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <option value="ACTIVE">ACTIVE</option>
          <option value="INACTIVE">INACTIVE</option>
        </select>
      );
    }

    return (
      <span 
        onClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium cursor-pointer hover:opacity-80 transition-opacity ${
          currentStatus === 'ACTIVE' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' :
          'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
        }`}
        title="Click to change status"
      >
        <span className={`w-1.5 h-1.5 rounded-full ${currentStatus === 'ACTIVE' ? 'bg-green-500' : 'bg-red-500'}`}></span>
        {currentStatus}
      </span>
    );
  };

  const getStatusBadge = (status: string) => {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
        status === 'ACTIVE' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' :
        'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
      }`}>
        <span className={`w-1.5 h-1.5 rounded-full ${status === 'ACTIVE' ? 'bg-green-500' : 'bg-red-500'}`}></span>
        {status}
      </span>
    );
  };

  return (
    <div className="overflow-x-auto">
      <Table className="min-w-full">
        <Table.Head className="bg-gray-50 dark:bg-gray-800 border-b-2 border-gray-200 dark:border-gray-700">
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Company
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Website
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Phone
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Sector
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Size
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Status
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Account Manager
          </Table.HeadCell>
          <Table.HeadCell className="px-4 py-3 text-center text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase">
            Actions
          </Table.HeadCell>
        </Table.Head>
        <Table.Body className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
          {loading ? (
            <Table.Row>
              <Table.Cell colSpan={8} className="text-center py-12">
                <div className="flex flex-col justify-center items-center">
                  <FadeLoader color="#3b82f6" />
                  <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">Loading companies...</p>
                </div>
              </Table.Cell>
            </Table.Row>
          ) : paginatedCompanies.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan={8} className="text-center py-12">
                <div className="flex flex-col items-center justify-center">
                  <HiOfficeBuilding className="w-16 h-16 text-gray-300 dark:text-gray-600 mb-3" />
                  <p className="text-lg font-medium text-gray-900 dark:text-white mb-1">
                    No companies found
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    Create your first company to get started
                  </p>
                </div>
              </Table.Cell>
            </Table.Row>
          ) : (
            paginatedCompanies.map((company: any) => {
              const accountManager = company.accountManager && typeof company.accountManager === 'object'
                ? `${company.accountManager.firstName || ''} ${company.accountManager.lastName || ''}`.trim() || company.accountManager.email || 'Unknown'
                : 'Unknown';

              return (
                <Table.Row
                  key={company.id}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                >
                  {/* Company Name */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-purple-500 flex items-center justify-center text-white font-semibold text-sm">
                        {company.name?.substring(0, 2).toUpperCase() || "CO"}
                      </div>
                      <div>
                        <div className="font-medium text-sm text-gray-900 dark:text-white">
                          {company.name || "N/A"}
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                          {company.city || ""} {company.stateAbbr || ""}
                        </div>
                      </div>
                    </div>
                  </Table.Cell>

                  {/* Website */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    {company.website ? (
                      <a
                        href={company.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
                      >
                        {company.website}
                      </a>
                    ) : (
                      <span className="text-sm text-gray-400">-</span>
                    )}
                  </Table.Cell>

                  {/* Phone */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    {company.phoneNumber ? (
                      <a
                        href={`tel:${company.phoneNumber}`}
                        className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
                      >
                        {company.phoneNumber}
                      </a>
                    ) : (
                      <span className="text-sm text-gray-400">-</span>
                    )}
                  </Table.Cell>

                  {/* Sector */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900 dark:text-white">{company.sector || "-"}</span>
                  </Table.Cell>

                  {/* Size */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900 dark:text-white">{company.size || "-"}</span>
                  </Table.Cell>

                  {/* Status */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <InlineStatusEditor status={company.status || "INACTIVE"} companyId={company.id} onUpdate={onUpdate} />
                  </Table.Cell>

                  {/* Account Manager */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm text-gray-900 dark:text-white">{accountManager}</span>
                  </Table.Cell>

                  {/* Actions */}
                  <Table.Cell className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center gap-2">
                      <EditCompanyModal company={company} onUpdate={onUpdate} />
                      <DeleteCompanyModal company={company} onUpdate={onUpdate} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            })
          )}
        </Table.Body>
      </Table>
    </div>
  );
};
const EXCLUDED_FIELDS = ["id", "accountManagerId", "createdAt", "updatedAt","accountManager"];

export const EditCompanyModal: FC<{ company: any, onUpdate: any }> = ({ company, onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(company);
  console.log("thisisformdata",formData);
  const handleChange = (key: string, value: any) => {
    setFormData((prev: any) => ({ ...prev, [key]: value }));
  };

  const handleArrayChange = (key: string, index: number, value: string) => {
    const updatedArray = [...(formData[key] || [])];
    updatedArray[index] = value;
    handleChange(key, updatedArray);
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      const updatePayload = { ...formData };
      await companyService.updateCompany(company.id, updatePayload);
      setOpen(false);
      onUpdate(); // refresh data
    } catch (error) {
      console.error("Failed to update company", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        color="primary"
        onClick={(e: any) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <div className="flex items-center gap-x-2">
          <HiOutlinePencilAlt className="text-lg" />
          Edit
        </div>
      </Button>

      <Modal
        size="xl"
        onClick={(e) => e.stopPropagation()}
        onClose={() => setOpen(false)}
        show={isOpen}
      >
        <Modal.Header className="border-b border-gray-200 !p-4 dark:border-gray-700">
          <strong>Edit Company</strong>
        </Modal.Header>
        <Modal.Body className="max-h-[70vh] overflow-y-auto">
          <div className="space-y-4">
            {/* Basic Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Company Name */}
                <div className="flex flex-col sm:col-span-2">
                  <Label htmlFor="name" className="mb-1 text-sm">
                    Company Name <span className="text-red-500">*</span>
                  </Label>
                  <TextInput
                    id="name"
                    name="name"
                    value={formData.name || ""}
                    onChange={(e) => handleChange("name", e.target.value)}
                    required
                    sizing="sm"
                  />
                </div>

                {/* Website */}
                <div className="flex flex-col">
                  <Label htmlFor="website" className="mb-1 text-sm">Website</Label>
                  <TextInput
                    id="website"
                    name="website"
                    type="url"
                    value={formData.website || ""}
                    onChange={(e) => handleChange("website", e.target.value)}
                    sizing="sm"
                  />
                </div>

                {/* LinkedIn URL */}
                <div className="flex flex-col">
                  <Label htmlFor="linkedinUrl" className="mb-1 text-sm">LinkedIn URL</Label>
                  <TextInput
                    id="linkedinUrl"
                    name="linkedinUrl"
                    type="url"
                    value={formData.linkedinUrl || ""}
                    onChange={(e) => handleChange("linkedinUrl", e.target.value)}
                    sizing="sm"
                  />
                </div>

                {/* Phone Number */}
                <div className="flex flex-col">
                  <Label htmlFor="phoneNumber" className="mb-1 text-sm">Phone Number</Label>
                  <TextInput
                    id="phoneNumber"
                    name="phoneNumber"
                    value={formData.phoneNumber || ""}
                    onChange={(e) => handleChange("phoneNumber", e.target.value)}
                    sizing="sm"
                  />
                </div>
              </div>
            </div>

            {/* Location Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Location Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Address */}
                <div className="flex flex-col sm:col-span-2">
                  <Label htmlFor="address" className="mb-1 text-sm">Address</Label>
                  <TextInput
                    id="address"
                    name="address"
                    value={formData.address || ""}
                    onChange={(e) => handleChange("address", e.target.value)}
                    sizing="sm"
                  />
                </div>

                {/* City */}
                <div className="flex flex-col">
                  <Label htmlFor="city" className="mb-1 text-sm">City</Label>
                  <TextInput
                    id="city"
                    name="city"
                    value={formData.city || ""}
                    onChange={(e) => handleChange("city", e.target.value)}
                    sizing="sm"
                  />
                </div>

                {/* State */}
                <div className="flex flex-col">
                  <Label htmlFor="stateAbbr" className="mb-1 text-sm">State/Province</Label>
                  <select
                    id="stateAbbr"
                    name="stateAbbr"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.stateAbbr || ""}
                    onChange={(e) => handleChange("stateAbbr", e.target.value)}
                  >
                    <option value="">Select State</option>
                    {US_STATES.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Zipcode */}
                <div className="flex flex-col">
                  <Label htmlFor="zipcode" className="mb-1 text-sm">Zip/Postal Code</Label>
                  <TextInput
                    id="zipcode"
                    name="zipcode"
                    value={formData.zipcode || ""}
                    onChange={(e) => handleChange("zipcode", e.target.value)}
                    sizing="sm"
                  />
                </div>

                {/* Country */}
                <div className="flex flex-col">
                  <Label htmlFor="country" className="mb-1 text-sm">Country</Label>
                  <select
                    id="country"
                    name="country"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.country || ""}
                    onChange={(e) => handleChange("country", e.target.value)}
                  >
                    {COUNTRY_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Business Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Business Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Sector */}
                <div className="flex flex-col">
                  <Label htmlFor="sector" className="mb-1 text-sm">Sector</Label>
                  <select
                    id="sector"
                    name="sector"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.sector || ""}
                    onChange={(e) => handleChange("sector", e.target.value)}
                  >
                    {SECTOR_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Size */}
                <div className="flex flex-col">
                  <Label htmlFor="size" className="mb-1 text-sm">Company Size</Label>
                  <select
                    id="size"
                    name="size"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.size || ""}
                    onChange={(e) => handleChange("size", e.target.value)}
                  >
                    {SIZE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Status */}
                <div className="flex flex-col">
                  <Label htmlFor="status" className="mb-1 text-sm">Status</Label>
                  <select
                    id="status"
                    name="status"
                    className="border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1.5 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    value={formData.status || "ACTIVE"}
                    onChange={(e) => handleChange("status", e.target.value)}
                  >
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                  </select>
                </div>

                {/* Revenue */}
                <div className="flex flex-col">
                  <Label htmlFor="revenue" className="mb-1 text-sm">Revenue</Label>
                  <TextInput
                    id="revenue"
                    name="revenue"
                    value={formData.revenue || ""}
                    onChange={(e) => handleChange("revenue", e.target.value)}
                    sizing="sm"
                  />
                </div>

                {/* Tax Identifier */}
                <div className="flex flex-col">
                  <Label htmlFor="taxIdentifier" className="mb-1 text-sm">Tax ID</Label>
                  <TextInput
                    id="taxIdentifier"
                    name="taxIdentifier"
                    value={formData.taxIdentifier || ""}
                    onChange={(e) => handleChange("taxIdentifier", e.target.value)}
                    sizing="sm"
                  />
                </div>
              </div>
            </div>

            {/* Additional Information Section */}
            <div>
              <h3 className="text-base font-semibold mb-3 text-gray-900 dark:text-white">Additional Information</h3>
              
              {/* Description */}
              <div className="mb-3">
                <Label htmlFor="description" className="mb-1 text-sm">Description</Label>
                <textarea
                  id="description"
                  name="description"
                  rows={3}
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  value={formData.description || ""}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>

              {/* Context Links */}
              {Array.isArray(formData.contextLinks) && formData.contextLinks.length > 0 && (
                <div className="mb-3">
                  <Label className="mb-1 text-sm block">Context Links</Label>
                  {formData.contextLinks.map((link: string, index: number) => (
                    <TextInput
                      key={index}
                      placeholder={`Context Link ${index + 1}`}
                      value={link}
                      onChange={(e) => handleArrayChange("contextLinks", index, e.target.value)}
                      className="mt-1 mb-2"
                      sizing="sm"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-t border-gray-200 dark:border-gray-700 !p-4">
          <div className="flex justify-end gap-2 w-full">
            <Button
              color="gray"
              onClick={() => setOpen(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const DeleteCompanyModal: FC<{ company: any; onUpdate: () => void }> = ({ company, onUpdate }) => {
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await companyService.deleteCompany(company.id);
      setOpen(false);
      toast.success("Company Deleted Sucessfully!")
      onUpdate(); // refresh list
    } catch (error) {
      toast.error("Error while deleting the company!")
      console.error("Delete failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button color="failure" onClick={(e: any) => {
        e.stopPropagation();
        setOpen(true);
      }}>
        <div className="flex items-center gap-x-2">
          <HiTrash className="text-lg" />
          Delete
        </div>
      </Button>

      <Modal onClose={() => setOpen(false)} show={isOpen} size="md">
        <Modal.Header className="px-6 pb-0 pt-6">
          <span className="sr-only">Delete company</span>
        </Modal.Header>
        <Modal.Body className="px-6 pb-6 pt-0">
          <div className="flex flex-col items-center gap-y-6 text-center">
            <HiOutlineExclamationCircle className="text-7xl text-red-500" />
            <p className="text-xl text-gray-500">
              Are you sure you want to delete this company?
            </p>
            <div className="flex items-center gap-x-3">
              <Button color="failure" onClick={handleDelete} isProcessing={loading}>
                Yes, I'm sure
              </Button>
              <Button color="gray" onClick={(e: any) => { e.stopPropagation(); setOpen(false) }} disabled={loading}>
                No, cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  setCurrentPage: (page: number) => void;
}
export const Pagination: FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  setCurrentPage,
}) => {
  return (
    <div className="sticky bottom-0 right-0 w-full items-center border-t border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex sm:justify-between">
      <div className="mb-4 flex items-center sm:mb-0 space-x-2">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
          className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50"
        >
          <HiChevronLeft className="text-2xl" />
        </button>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
          className="inline-flex cursor-pointer justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50"
        >
          <HiChevronRight className="text-2xl" />
        </button>

        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
          Showing&nbsp;
          <span className="font-semibold text-gray-900 dark:text-white">
            {(currentPage - 1) * itemsPerPage + 1}-
            {Math.min(currentPage * itemsPerPage, totalItems)}
          </span>
          &nbsp;of&nbsp;
          <span className="font-semibold text-gray-900 dark:text-white">
            {totalItems}
          </span>
        </span>
      </div>

      <div className="flex items-center space-x-2 mt-2 sm:mt-0">
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={`px-3 py-1 rounded text-sm ${currentPage === i + 1
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-white"
              }`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserListPage;
